import { render, staticRenderFns } from "./FranchiseTotalizer.vue?vue&type=template&id=48bdbc93&scoped=true"
import script from "./FranchiseTotalizer.vue?vue&type=script&lang=js"
export * from "./FranchiseTotalizer.vue?vue&type=script&lang=js"
import style0 from "./FranchiseTotalizer.vue?vue&type=style&index=0&id=48bdbc93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bdbc93",
  null
  
)

export default component.exports